import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getMockedChallenge } from '../../../main/getMockedChallenges';
import type { Step } from '../../../../types/v3Types';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { loadStepsInChunks } from '../../../../utils/loadStepsInChunks';

export default async function requestChallengeSteps(
  programId: string,
  flowAPI: ControllerFlowAPI,
  limit?: number,
): Promise<Step[]> {
  if (limit === 0) {
    return [];
  }
  const mockedChallenge = getMockedChallenge(programId, flowAPI);
  if (!programId) {
    return null;
  } else if (mockedChallenge) {
    return [];
  }

  try {
    return await loadStepsInChunks({ programId, flowAPI });
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);
    handleError({
      error,
      resolvedError,
      context: 'requestChallengeSteps',
      preventErrorMonitorReport: false,
    });
    return [];
  }
}
